import { render } from "./AboutusPage.vue?vue&type=template&id=7d1d62e6"
import script from "./AboutusPage.vue?vue&type=script&lang=js"
export * from "./AboutusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__